module.exports = __webpack_public_path__ + "img/160.546063f9.jpg";